<template>
  <div class="pageItem">
    <v-dialog v-model="dialog_imgs" max-width="700">
      <v-card class="d-flex call-dialog thanks-dialog images-dialog">
        <a @click="dialog_imgs = false" class="dialog-close">
          <img src="../assets/img/close.svg" alt="" />
        </a>
        <v-card-text>
          <img @click="prevImg" class="leftArrow" src="@/assets/img/leftArrow.svg" />
          <img style="width: 100%; height: 100%" :src="url + 'images/' + targetImage" />
          <img @click="nextImg" class="rightArrow" src="@/assets/img/leftArrow.svg" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <div class="breadcrumbs">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>

    <div class="category__panels">
      <vue-horizontal responsive>
        <a :href="'/item?id=' + item.id" v-for="item in sub_cateogrys" :key="item.id">
          <div class="category__panels-item">
            <img :src="url + 'images/' + item.image" alt="" />
            <h2>{{ item.name }}</h2>
          </div>
        </a>
      </vue-horizontal>
    </div>

    <h1>{{ title }}</h1>

    <div class="pageItem-wrapper">
      <div class="pageItem-left">
        <div class="pageItem-photos">
          <div class="pageItem-mainPhoto">
            <img @click="dialog_imgs = true" :src="url + 'images/' + targetImage" alt="" />
          </div>
          <div class="pageItem-galery">
            <div
              class="pageItem-galery--item"
              v-for="item in images"
              :key="item.id"
              :class="item.name == targetImage ? 'galery-active' : ''"
            >
              <img @click="targetImage = item.name" :src="url + 'images/' + item.name" alt="" />
            </div>
          </div>
        </div>
        <div class="description">
          <p>{{ description }}</p>
        </div>
      </div>

      <div class="pageItem-right">
        <div class="pageItem-actions">
          <div class="pageItem-hasIs">
            <img v-if="hasIs" src="../assets/img/tick.svg" />
            <img v-else src="../assets/img/tick_grey.svg" />
            <span v-if="hasIs">В наличии</span>
            <span v-else>Отсутствует</span>
          </div>

          <div class="pageItem-variable">
            <div class="pageItem-filter pa-4">
              <v-row dense>
                <v-col v-for="attr in visibleFilterAttributes" :key="attr" cols="12">
                  <div class="filter-row">
                    <div class="filter-row__label">{{ attr }}</div>
                    <div class="filter-row__control">
                      <v-select
                        v-model="filters[attr]"
                        :items="getUniqueValuesFor(attr)"
                        label="Выберите"
                        outlined
                        dense
                        clearable
                        hide-details
                      />
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" class="mt-2">
                  <v-btn color="secondary" small text @click="clearFilters">
                    Сбросить все фильтры
                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <div class="table-scroll-wrapper" v-if="filteredTableData.length">
              <v-simple-table
                class="pageItem-table"
                fixed-header
                height="350px"
              >
                <thead>
                  <tr>
                    <th v-for="(col, i) in tableColumns" :key="i">{{ col }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(row, i) in filteredTableData"
                    :key="i"
                    :class="{ 'selected-row': selectedKey === i }"
                    @click="selectRow(row, i)"
                  >
                    <td v-for="(col, j) in tableColumns" :key="j">
                      {{ row[col] }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>

            <div v-if="selectedRow" class="pageItem-variable--count">
              <div class="item-count--wrapper">
                <v-icon @click="itemMinusCount">mdi-minus</v-icon>
                <input @keypress="onlyNumber" type="text" class="item-count" v-model="count" />
                <v-icon @click="itemPlusCount">mdi-plus</v-icon>
              </div>

              <v-btn
      block
      height="50"
      color="primary"
      class="add-to-cart-btn mt-2"
      @click="addItem"
    >
      <v-icon left>mdi-cart-outline</v-icon>
      В корзину
    </v-btn>

              <div class="pageItem-variable--priceBlock">
                <h2>Итого <b>{{ totalPrice.toLocaleString() }}</b> ₽</h2>
                <h3 v-if="price !== initPrice" class="old-price">
                  Обычная цена: {{ initPrice.toLocaleString() }} ₽
                </h3>
                <h3>Цена за 1 шт: {{ price.toLocaleString() }} ₽</h3>

                <div class="pageItem-variable--salePrice" v-if="sales.length">
                  <ul class="item-bottom-price">
                    <li v-for="sale in sales" :key="sale.id" class="item-bottom-el">
                      <span>от {{ sale.count }} шт.</span>
                      <span>{{ sale.price }} ₽ / шт.</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pageItem-delivery">
          <h3>Доставка</h3>
          <div class="pageItem-delivery--item">
            <img src="../assets/img/time.svg" alt="" />
            <h6>Бесплатная доставка по Москве при заказе от 40 тыс.рублей</h6>
          </div>
          <div class="pageItem-delivery--item mt-5">
            <h6 class="mb-2">Отправка транспортными компаниями:</h6>
            <div class="logotips">
              <img src="../assets/img/baikal.png" alt="Байкал" />
              <img src="../assets/img/pek.png" alt="ПЭК" />
              <img src="../assets/img/cdek.png" alt="СДЭК" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router";
import api from "../api";
import VueHorizontal from "vue-horizontal";

export default {
  name: "Item",
  watch: {
    "$route.query.id": {
    immediate: false,
    handler(newId) {
      if (!newId) return;
      this.item_id = newId;
      this.initItem();          // <-- ВАЖНО
    },
  },
    count() {
      this.checkSale();
    },

    tableData(newVal) {
      if (newVal.length > 0 && Object.keys(this.filters).length === 0) {
        this.$nextTick(this.initFiltersFromAttributes);
      }
    },

    item_id() {
      this.$nextTick(this.initFiltersFromAttributes);
    },

    additionalValue() {
      if (this.hugeArr.find((el) => el.values.length > 1)) {
        this.hugeArr.find((el) => el.values.length > 1).disabled = false;
        this.changeArr.forEach((el) => {
          el.value = null;
        });
        this.resetData();
      } else {
        this.setAdditional();
        return;
      }
    },

    // глубокий вотчер для фасетов
    filters: {
      deep: true,
      handler() {
        this.resetSelection();
      },
    },
  },
  data: () => ({
    itemFiltersConfig: {
      1: ["Наличие клеевого слоя", "Толщина"],
      2: ["Наличие клеевого слоя"],
      3: ["Ширина", "Тип"],
      4: ["Ширина"],
      5: ["Ширина"],
      6: ["Ширина"],
      7: ["Ширина"],
      8: ["Ширина"],
      9: ["Тип", "Ширина"],
      11: ["Ширина"],
    },
    target_attribute: null,
    target_length: null,
    target_wide: null,
    tableData: [],
    selectedRow: null,
    selectedKey: null,
    filters: {},

    target_thickness: null,
    url: process.env.VUE_APP_ROOT_API,
    count: 1,
    hasIs: true,
    haveClue: false,
    initPrice: 0,
    price: 0,
    totalPrice: 0,
    sales: [],
    title: "",
    description: "",
    thickness: "",
    wide: "",
    length: "",
    itemFavorites: false,
    targetImage: "",
    tab: "",
    finalPrice: 0,
    images: [],
    itemChar: [],
    category_id: 0,
    item_id: router.history.current.query.id,
    dopItems: [],
    dlina: [],
    thickness_arr: [],
    wide_arr: [],
    length_arr: [],
    breadcrumbs: [
      { text: "Главная", disabled: false, href: "/" },
      { text: "Каталог", disabled: false, href: "/catalog" },
    ],
    sub_cateogrys: [],
    attributes: [],
    additionalInfo: false,
    additionalInfoArr: [],
    additionalValue: "",
    hugeArr: [],
    hugeArrInit: [],
    changeArr: [],
    lastIndex: null,
    additionalInfoDisabled: false,
    additionalInfoName: "",
    dialog_imgs: false,
  }),
  computed: {
  tableColumns() {
    if (!Array.isArray(this.tableData) || !this.tableData.length) return [];

    const cols = [];
    const seen = new Set();

    // 1. Собираем уникальные ключи из данных
    for (const row of this.tableData) {
      for (const k of Object.keys(row)) {
        if (!k || k.startsWith("_")) continue;
        if (!seen.has(k)) {
          seen.add(k);
          cols.push(k);
        }
      }
    }

    // 2. Дефолтная сортировка (когда нет конфига): Ширина в начало
    const wIdx = cols.findIndex(
      (c) => c === "Ширина" || (typeof c === "string" && c.startsWith("Ширина"))
    );
    if (wIdx > 0) {
      const [w] = cols.splice(wIdx, 1);
      cols.unshift(w);
    }

    // 3. Дефолтная сортировка: Цена в конец
    const pIdx = cols.indexOf("Цена");
    if (pIdx >= 0) {
      const [p] = cols.splice(pIdx, 1);
      cols.push(p);
    }

    return cols;
  },

  // Вспомогательный список всех доступных атрибутов (без Цены)
  // Служит "базой" для фильтров
  filterAttributes() {
    return this.tableColumns.filter((c) => c !== "Цена");
  },

  visibleFilterAttributes() {
    const allowed = this.itemFiltersConfig[this.item_id];

    // Если есть конфиг для этого ID
    if (Array.isArray(allowed) && allowed.length) {
      // Возвращаем атрибуты строго в порядке из конфига,
      // но только те, которые реально есть в данных таблицы
      return allowed.filter(attr => this.filterAttributes.includes(attr));
    }

    // Если конфига нет — возвращаем всё из filterAttributes.
    // Там "Ширина" уже гарантированно первая благодаря логике в tableColumns.
    return this.filterAttributes;
  },

  filteredTableData() {
    let rows = this.tableData || [];
    for (const [k, v] of Object.entries(this.filters)) {
      if (v) rows = rows.filter((r) => r[k] === v);
    }
    return rows;
  },
},
  methods: {
    // Инициализация фасетов
    initFiltersFromAttributes() {
      const keys = this.visibleFilterAttributes;
      const next = {};
      keys.forEach((k) => (next[k] = ""));
      this.filters = next;
    },

    // Значения для конкретного фасета с учётом выбранных остальных
    getUniqueValuesFor(attr) {
      let rows = this.tableData;
      for (const [k, v] of Object.entries(this.filters)) {
        if (k !== attr && v) rows = rows.filter((r) => r[k] === v);
      }
      const values = rows.map((r) => r[attr]).filter(Boolean);
      return [...new Set(values)];
    },

    // метод clearFilter оставлен на будущее, но не используется в шаблоне
    clearFilter(attr) {
      if (this.filters[attr]) {
        this.$set(this.filters, attr, "");
      }
    },

    resetSelection() {
      this.selectedRow = null;
      this.selectedKey = null;
      this.price = 0;
      this.totalPrice = 0;
      this.sales = [];
    },

    clearFilters() {
      const next = { ...this.filters };
      Object.keys(next).forEach((k) => (next[k] = ""));
      this.filters = next;
      this.resetSelection();
    },

    recalculatePrice() {
      if (!this.selectedRow) {
        this.price = 0;
        this.totalPrice = 0;
        return;
      }
      let unitPrice = this.initPrice;
      if (this.sales && this.sales.length) {
        const sorted = [...this.sales].sort((a, b) => a.count - b.count);
        for (let i = sorted.length - 1; i >= 0; i--) {
          if (this.count >= sorted[i].count) {
            unitPrice = Number(sorted[i].price);
            break;
          }
        }
      }
      this.price = unitPrice;
      this.totalPrice = this.count * unitPrice;
    },

    selectRow(row, index) {
      this.selectedRow = row;
      this.selectedKey = index;
      let basePrice = parseFloat(
        (row["Цена"] || "0").toString().replace(/[^\d.]/g, "")
      );
      this.initPrice = basePrice;
      this.sales = row._sales || [];
      this.recalculatePrice();
    },

    changeParam(name) {
      this.resetData();

      let countFull = 0;

      this.hugeArrInit.forEach((el) => {
        if (el.values.length == 1) {
          countFull++;
          this.changeArr.find((i) => i.name == el.name).value = el.values[0];
        }
      });

      if (countFull == this.hugeArrInit.length) {
        let fFilter = this.changeArr[0];
        let atrs = this.attributes.filter(
          (el) =>
            el.param.find((i) => i.name == fFilter.name).value == fFilter.value
        );
        if (atrs.length > 1) {
          this.additionalInfoDisabled = false;
          return;
        }
        this.target_attribute = atrs[0];
        this.changeData();
        return;
      }

      let index = this.hugeArr.indexOf(
        this.hugeArr.find((el) => el.name == name)
      );

      for (let i = index + 1; i < this.changeArr.length; i++) {
        this.changeArr[i].value = null;
        this.hugeArr[i].disabled = true;
      }

      this.lastIndex = index;

      let fFilter = this.changeArr[0];
      let atrs = this.attributes.filter(
        (el) =>
          el.param.find((i) => i.name == fFilter.name).value == fFilter.value
      );

      this.changeArr.forEach((change) => {
        if (change.value) {
          atrs = atrs.filter(
            (el) =>
              el.param.find((i) => i.name == change.name).value == change.value
          );

          for (let i = index + 1; i < this.hugeArr.length; i++) {
            this.hugeArr[i].disabled = false;
            this.hugeArr[i].values = [];
            atrs.forEach((el) => {
              let atr = el.param.find((e) => e.name == this.hugeArr[i].name);
              this.hugeArr[i].values.push(atr.value);
            });
          }
        }
      });

      if (atrs.length == 1) {
        atrs[0].param.forEach((el) => {
          if (el.value)
            this.changeArr.find((i) => i.name == el.name).value = el.value;
        });
      } else {
        if (index + 1 !== this.hugeArr.length) {
          if (this.hugeArr[index + 1].values.length == 1) {
            if (this.hugeArr[index + 2]) {
              this.hugeArr[index + 2].disabled = false;
              this.hugeArr[index + 2].values = [];
              atrs.forEach((el) => {
                let atr = el.param.find(
                  (i) => i.name == this.hugeArr[index + 2].name
                );
                this.hugeArr[index + 2].values.push(atr.value);
              });
            }
          } else {
            this.hugeArr[index + 1].disabled = false;
            this.hugeArr[index + 1].values = [];
            atrs.forEach((el) => {
              let atr = el.param.find(
                (i) => i.name == this.hugeArr[index + 1].name
              );
              this.hugeArr[index + 1].values.push(atr.value);
            });
          }
          this.hugeArr.forEach((el) => {
            el.values = [...new Set(el.values)];
          });

          for (let i = index + 1; i < this.hugeArr.length; i++) {
            if (this.hugeArr[i].values.length == 1) {
              this.changeArr[i].value = this.hugeArr[i].values[0];
            }
          }
        }
      }

      let fullIs = false;

      for (let i = 0; i < this.changeArr.length; i++) {
        if (!this.changeArr[i].value) {
          fullIs = false;
          break;
        } else {
          fullIs = true;
        }
      }
      if (fullIs) {
        if (!this.additionalInfo) {
          this.target_attribute = atrs[0];
          this.changeData();
        } else {
          this.setAdditional();
        }
      }
      if (this.item_id == 9) {
        if (this.hugeArr.find((el) => el.name == "Втулка").values[0])
          this.hugeArr.find((el) => el.name == "Втулка").values =
            this.hugeArr.find((el) => el.name == "Втулка").values[0];
        else
          this.hugeArr.find((el) => el.name == "Втулка").values =
            this.hugeArr.find((el) => el.name == "Втулка").values;
      }
    },

    setAdditional() {
      if (this.additionalValue) {
        let fFilter = this.changeArr[0];
        let atrs = this.attributes.filter(
          (el) =>
            el.param.find((i) => i.name == fFilter.name).value == fFilter.value
        );

        this.changeArr.forEach((change) => {
          if (change.value) {
            atrs = atrs.filter(
              (el) =>
                el.param.find((i) => i.name == change.name).value ==
                change.value
            );
          }
        });

        this.target_attribute = atrs.find(
          (el) =>
            el.param.find((i) => i.name == this.additionalInfoName)
              .additional == this.additionalValue
        );
        this.changeData();
      }
    },

    changeData() {
      if (this.target_attribute) {
        this.itemChar = [];
        this.target_attribute.param.forEach((el) => {
          if (el.value)
            this.itemChar.push({
              name: el.name,
              value: el.value + " " + el.unit,
            });
        });
        this.sales = [];
        if (this.target_attribute.offer)
          this.target_attribute.offer.forEach((el) => {
            this.sales.push({
              id: el.id,
              count: el.offer,
              price: el.offer_price,
            });
          });

        this.initPrice = this.target_attribute.price;
        this.checkSale();
      } else {
        this.resetData();
      }
    },

    resetData() {
      if (this.item_id == 1) {
        if (this.hugeArr.find((el) => el.name == "Длина").values[0])
          this.hugeArr.find((el) => el.name == "Длина").values =
            this.hugeArr.find((el) => el.name == "Длина").values[0];
        else
          this.hugeArr.find((el) => el.name == "Длина").values =
            this.hugeArr.find((el) => el.name == "Длина").values;
      }
      if (this.item_id == 9) {
        if (this.hugeArr.find((el) => el.name == "Втулка").values[0])
          this.hugeArr.find((el) => el.name == "Втулка").values =
            this.hugeArr.find((el) => el.name == "Втулка").values[0];
        else
          this.hugeArr.find((el) => el.name == "Втулка").values =
            this.hugeArr.find((el) => el.name == "Втулка").values;
      }
      this.target_attribute = null;
      this.itemChar = [];
      this.hugeArrInit.forEach((el) => {
        if (el.values.length == 1) {
          this.itemChar.push({
            name: el.name,
            value: el.values[0] + ", " + el.unit,
          });
        }
      });
      this.sales = [];
      this.initPrice = 0;
      this.checkSale();
    },

    async initItem() {
  // сброс базовых состояний, чтобы при смене id не оставался мусор
  this.title = "";
  this.description = "";
  this.images = [];
  this.targetImage = "";
  this.category_id = 0;

  this.attributes = [];
  this.tableData = [];
  this.selectedRow = null;
  this.selectedKey = null;

  this.itemChar = [];
  this.sales = [];
  this.initPrice = 0;
  this.price = 0;
  this.totalPrice = 0;

  this.additionalInfo = false;
  this.additionalInfoArr = [];
  this.additionalInfoName = "";

  this.hugeArr = [];
  this.hugeArrInit = [];
  this.changeArr = [];
  this.lastIndex = null;

  // фильтры — сбрасываем, но инициализацию сделаем после загрузки данных
  this.filters = {};

  // читаем id из роутера (на всякий случай)
  const rid = this.$route?.query?.id || router.history.current.query.id;
  this.item_id = rid;

  // === 1) грузим товар ===
  let res;
  try {
    res = await api.getItemById(this.item_id);
  } catch (e) {
    console.error("getItemById failed", e);
    return;
  }
  if (!res) return;

  this.title = res.name || "";
  this.description = res.description || "";
  this.images = Array.isArray(res.image) ? res.image : [];
  this.targetImage = this.images?.[0]?.name || "";
  this.category_id = res.category_id || 0;

  // хлебные крошки
  await this.initBreadCrumbs();

  // атрибуты
  this.attributes = Array.isArray(res.attribute) ? res.attribute : [];

  // === helper: нормализация значения для фильтров/таблицы ===
  const normalize = (v) =>
    String(v ?? "")
      .replace(/\r?\n/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  // === 2) строим tableData (каждый attr -> строка таблицы) ===
  this.tableData = this.attributes.map((attr) => {
    const row = {};

    // сохраняем порядок параметров как пришёл с бэка
    const params = Array.isArray(attr.param) ? attr.param : [];
    params.forEach((p) => {
      if (!p || !p.name) return;

      let valueStr = "";
      if (p.additional) {
        valueStr = normalize(p.additional);
      } else if (p.value !== null && p.value !== undefined) {
        valueStr = normalize(String(p.value) + (p.unit ? " " + p.unit : ""));
      } else {
        valueStr = "";
      }

      row[p.name] = valueStr;
    });

    row["Цена"] = Number(attr.price || 0);
    row._id = attr.id;

    row._sales = Array.isArray(attr.offer)
      ? attr.offer
          .map((o) => ({
            id: o.id,
            // offer у тебя может быть int или string — приводим в число где возможно
            count: Number(String(o.offer).replace(/[^\d]/g, "")) || 0,
            price: Number(o.offer_price || 0),
          }))
          .filter((x) => x.count > 0 && x.price > 0)
      : [];

    return row;
  });

  // === 3) строим hugeArrInit для старого UI выбора параметров (если он ещё используется) ===
  // ВАЖНО: тут фиксируем порядок параметров как приходит (первое появление)
  const seen = new Set();

  this.attributes.forEach((a) => {
    const params = Array.isArray(a.param) ? a.param : [];
    params.forEach((el) => {
      if (!el || !el.name) return;

      // additional: собираем отдельный список
      if (el.additional) {
        this.additionalInfo = true;
        this.additionalInfoName = el.name;
        this.additionalInfoArr.push(normalize(el.additional));
        return;
      }

      // value: идёт в hugeArrInit
      if (el.value === null || el.value === undefined) return;

      const v = normalize(el.value);
      if (!seen.has(el.name)) {
        seen.add(el.name);
        this.hugeArrInit.push({
          name: el.name,
          unit: el.unit || "",
          values: [v],
          disabled: true,
        });
      } else {
        const it = this.hugeArrInit.find((i) => i.name === el.name);
        if (it) it.values.push(v);
      }
    });
  });

  // уникализируем значения в hugeArrInit (сохраняя порядок)
  this.hugeArrInit.forEach((el) => {
    const uniq = [];
    const set = new Set();
    el.values.forEach((v) => {
      if (!set.has(v)) {
        set.add(v);
        uniq.push(v);
      }
    });
    el.values = uniq;
  });

  // additionalInfoArr уникализируем
  if (this.additionalInfoArr && this.additionalInfoArr.length) {
    const uniq = [];
    const set = new Set();
    this.additionalInfoArr.forEach((v) => {
      if (!set.has(v)) {
        set.add(v);
        uniq.push(v);
      }
    });
    this.additionalInfoArr = uniq;
  }

  // hugeArr и changeArr
  this.hugeArr = JSON.parse(JSON.stringify(this.hugeArrInit));
  this.changeArr = this.hugeArr.map((el) => ({ name: el.name, value: null }));

  // === 4) фасеты/фильтры: инициализируем только если есть правила ===
  // (металфурнитура обычно без фасетов — тогда filters останется пустым и таблица покажет все строки)
  this.$nextTick(() => this.initFiltersFromAttributes());

  // === 5) дефолтная логика выбора/цены ===
  // если вариантов ровно 1 — выберем её сразу
  if (this.tableData.length === 1) {
    this.selectRow(this.tableData[0], 0);
  } else {
    // иначе просто сброс
    this.resetSelection();
  }

  // Debug (можно оставить временно)
  console.log("tableData:", this.tableData.length);
  console.log("filteredTableData:", this.filteredTableData?.length);
  console.log("filters:", JSON.parse(JSON.stringify(this.filters)));
},


    checkSale() {
      let breakFor = false;
      this.price = this.initPrice;
      if (this.sales) {
        for (var i = this.sales.length - 1; i >= 0; i--) {
          let s = this.sales[i];
          if (this.count >= s.count) {
            if (breakFor) return;
            this.price = s.price;
            this.totalPrice = this.count * this.price;
            breakFor = true;
          }
        }
      }
      this.totalPrice = this.count * this.price;
    },

    itemPlusCount() {
      this.count++;
      this.recalculatePrice();
    },
    itemMinusCount() {
      if (this.count > 1) {
        this.count--;
        this.recalculatePrice();
      }
    },

    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 && keyCode !== 8) {
        $event.preventDefault();
      }
    },
    prettify(num) {
      var n = num.toString();
      var separator = " ";
      return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + separator);
    },
    addItem() {
  // Находим оригинальный объект атрибута по id из выбранной строки
  let target = this.attributes.find(
    (el) => el.id == this.selectedRow._id
  );

  if (!target) {
    alert("Пожалуйста, выберите товар в таблице");
    return;
  }

  let item = {
    attribute: target,
    title: this.title,
    id: this.item_id + "-" + target.id,
    category_id: this.category_id,
    image: this.targetImage,
    // wide, length и thickness берем из параметров атрибута или напрямую из строки
    wide: target.wide || this.selectedRow["Ширина"],
    price: this.initPrice,
    sale_price: this.price,
    sales: this.sales,
    description: this.description,
    length: target.length || this.selectedRow["Длина"],
    thickness: target.thickness || this.selectedRow["Толщина"],
    count: this.count,
  };

  this.$store.dispatch("add_item_in_backet", item);

  // Опционально: уведомление пользователя
  // alert("Товар добавлен в корзину");
},
    async initBreadCrumbs() {
      if (this.category_id) {
        let res = await api.getCategory(this.category_id);

        if (res) {
          this.sub_cateogrys = res.items;

          this.sub_cateogrys.forEach((i) => {
            if (i.image[0]) {
              i.image = i.image[0].name;
            }
          });

          this.breadcrumbs.push({
            text: res.name,
            disabled: false,
            href: "/category?id=" + res.id,
          });
        }
      } else {
        router.push("/catalog");
      }
    },
    addFavoiteItem(item) {
      this.$store.dispatch("toogle_favorites_item", item);
      item.favorites = !item.favorites;
    },
    nextImg() {
      let img = this.images.find((item) => item.name == this.targetImage);
      let index = this.images.indexOf(img);

      if (this.images[index + 1] !== undefined)
        this.targetImage = this.images[index + 1].name;
      else this.targetImage = this.images[0].name;
    },
    prevImg() {
      let img = this.images.find((item) => item.name == this.targetImage);
      let index = this.images.indexOf(img);

      if (this.images[index - 1] !== undefined)
        this.targetImage = this.images[index - 1].name;
      else this.targetImage = this.images[this.images.length - 1].name;
    },
  },
  mounted() {
    this.initItem();
  },
  components: { VueHorizontal },
};
</script>

<style lang="scss">
/* --- БАЗОВЫЕ ПЕРЕМЕННЫЕ И БЛОКИ ЦЕН --- */
.pageItem-variable--priceBlock {
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  h2 { margin-bottom: 5px; font-size: 28px; }
  h3 { margin: 2px 0; font-size: 16px; font-weight: 400; }

  .old-price { text-decoration: line-through; color: #999; }
  .pageItem-variable--salePrice { margin-top: 10px; }
}

.pageItem-table tr { cursor: pointer; }
.pageItem-table .selected-row { background: #e6f7ff !important; font-weight: 500; }

/* --- ДИАЛОГ ИЗОБРАЖЕНИЙ --- */
.images-dialog {
  position: relative;
  .rightArrow, .leftArrow {
    position: absolute; width: 25px; top: 50%;
    transform: translateY(-50%); cursor: pointer;
  }
  .leftArrow { left: 5px; transform: translateY(-50%) rotate(180deg); }
  .rightArrow { right: 5px; }
}

/* --- ФИЛЬТРЫ (СТРОКИ) --- */
.filter-box { border-radius: 8px; margin-bottom: 8px; }

.filter-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 6px 12px;

  .filter-row__label {
    min-width: 140px; /* Уменьшено: теперь названия фильтров занимают меньше места */
    font-weight: 600;
    color: #333;
    font-size: 14px;
    flex-shrink: 0;
  }

  .filter-row__control {
    flex: 1 1 auto;
    min-width: 0;
    .v-input--dense { margin: 0; }
  }
}

.pageItem-variable { display: flex; flex-direction: column; gap: 15px; width: 100%; }

.pageItem-filter {
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background: #fff;
  width: 100%;
}

/* --- ТАБЛИЦА (КОМПАКТНАЯ) --- */
/* Контейнер с прокруткой */
.table-scroll {
  height: 350px;              /* ЖЕСТКАЯ ВЫСОТА: подправь под себя (например, 300px или 400px) */
  overflow-y: auto;           /* Включаем вертикальный скролл */
  overflow-x: auto;           /* Оставляем горизонтальный скролл для узких экранов */
  border: 1px solid #eee;
  border-radius: 8px;
  background: #fff;
  width: 100%;

  /* Кастомизация скроллбара для красоты (необязательно) */
  &::-webkit-scrollbar {
    width: 6px;               /* ширина скролла */
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
}

.pageItem-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 100%;

  thead th {
    position: sticky;         /* ДЕЛАЕМ ШАПКУ ЛИПКОЙ */
    top: 0;                   /* Прилипает к верху контейнера .table-scroll */
    z-index: 10;              /* Чтобы была выше строк при скролле */
    background: #f8f8f8;      /* Фон шапки, чтобы она не была прозрачной */
    font-weight: 600;
    color: #333;
    padding: 10px;
    border-bottom: 2px solid #eee;
    text-align: left;
    font-size: 13px;
  }

  td {
    padding: 10px;
    border-bottom: 1px solid #eee;
    font-size: 13px;
  }

  tr:hover {
    background-color: #f5faff !important; /* Подсветка строки при наведении */
  }
}

/* --- ОБЩАЯ СТРУКТУРА СТРАНИЦЫ --- */
.pageItem {
  .pageItem-wrapper {
    display: flex;
    flex-wrap: wrap;
    column-gap: 40px;
    justify-content: flex-start;

    .pageItem-left {
      width: 55%; /* Левая часть с фото стала шире */
      flex-grow: 1;

      .pageItem-photos {
        .pageItem-mainPhoto {
          height: 440px;
          img { object-fit: contain; width: 100%; height: 100%; }
        }
        .pageItem-galery {
          display: flex; width: 100%; justify-content: flex-start; gap: 10px;
          &--item {
            border-radius: 4px; width: 80px; height: 80px; cursor: pointer;
            img { width: 100%; height: 100%; object-fit: contain; }
          }
          .galery-active { border: 2px solid #1c472f; }
        }
      }
      .description { margin-top: 20px; }
    }

    /* --- ПРАВАЯ КОЛОНКА (ГДЕ РЕГУЛИРУЕТСЯ ШИРИНА) --- */
    .pageItem-right {
      width: 100%;
      max-width: 480px; /* ФИКСИРОВАННАЯ ШИРИНА ДЛЯ КОМПА */
      flex-grow: 0;
      min-width: 0;

      .pageItem-actions {
        padding: 20px;
        box-shadow: 0px 0px 9px rgba(0,0,0,0.1);
        display: flex;
        flex-direction: column;
        border-radius: 8px;
        background: #fff;

        .pageItem-hasIs {
          display: flex; align-items: center; column-gap: 5px; margin-bottom: 20px;
        }

        .pageItem-variable--count {
          width: 100%; display: flex; flex-direction: column; align-items: flex-start;

          .item-count--wrapper {
            width: 140px; display: flex; justify-content: center; align-items: center;
            border: 2px solid #e4e4e4; border-radius: 4px; height: 44px; margin-bottom: 20px;
            input { text-align: center; width: 40px; border: none; outline: none; }
            .item-count-icon { cursor: pointer; font-size: 20px; }
          }
        }
      }

      .pageItem-delivery {
        margin-top: 20px; padding: 20px; box-shadow: 0px 0px 9px rgba(0,0,0,0.1);
        border-radius: 8px; background: #fff;
        .logotips { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; img { height: 20px; } }
      }
    }
  }
}

/* --- МОБИЛЬНАЯ АДАПТАЦИЯ --- */
@media screen and (max-width: 960px) {
  .pageItem .pageItem-wrapper {
    flex-direction: column;
    .pageItem-left, .pageItem-right {
      width: 100% !important;
      max-width: 100% !important;
    }
  }

  .filter-row {
    flex-wrap: wrap;
    .filter-row__label { min-width: 100%; }
  }
}

/* Дополнительные стили из вашего кода */
.pageItem .category__panels-item {
  margin: 10px 0; padding: 15px; border-radius: 4px;
  display: flex; justify-content: center; align-items: center;
  column-gap: 15px; height: 111px;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid transparent;
  &:hover { border: 1px solid var(--color); }
  h2 { font-size: 15px; line-height: 20px; color: #000; }
  img { width: 70px; height: 70px; object-fit: contain; }
}
</style>